<template>
  <div id="main">

      <v-card>
        <v-card-title>
          <span class="headline">View Grade Details</span>
          <v-spacer></v-spacer>
          <v-btn icon v-on:click="close" v-if="showX">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container fluid grid-list-md page>
            <v-layout wrap>

               <div v-if="isPhone" style="width: 100%; text-align: center; padding-bottom: 20px; margin-top: -40px">
<!--                  note the other way for some f-ing reason doesn't work-->
                  <div class="heading" style="font-size: 15pt; padding-bottom: 5px">
                     Coaching For This Lead
                  </div>
                  <audio style="width:50%;" controls="controls" :src="file_data"  type="audio/mp3"
                         controlsList="nodownload"
                         @play="player_event" @seeked="player_event" @pause="player_event"
                         @volumechange="player_event"
                         ref="mp3_player"
                  ></audio>
                  <div  style="width: 100%; text-align: center">


                     <table style="margin: auto" v-if="percent_played.length>0">
                        <tr>
                           <th>User</th>
                           <th>Email</th>
                           <th>Percent Listened</th>
                        </tr>
                        <tr v-for="item in percent_played" :key="item.email">
                           <td style="text-align: left">
                              {{item.name}}
                           </td>
                           <td style="text-align: left">
                              {{item.email}}
                           </td>
                           <td>
                              {{round(item.percent*100, 0)}}%
                           </td>
                        </tr>
                     </table>

                     <div style="width: 100%; height: 5px;"></div>
                     <v-divider ></v-divider>
                  </div>

               </div>


              <v-flex v-if="graded_lead2">
                <div class="heading">Grade: {{graded_lead2.grade_letter}}</div>
                <div class="heading">Sales People:
                  <span v-for="(sp, ix) in graded_lead2.sales_people" :key="sp.name">
                  {{sp.name}}{{separator(ix, graded_lead2.sales_people)}}
                  </span>

                </div>
                <div class="heading">Dealership: {{graded_lead2.dealership.name}}</div>
                <div class="heading">Lead Source: {{graded_lead2.info_lead.lead_source}}</div>
                <div class="heading">Curriculum: {{graded_lead2.curriculum.name}}</div>
                <div class="heading">Customer: {{graded_lead2.info_customer.name_first}} {{graded_lead2.info_customer.name_last}}</div>
                <div class="heading">Vehicle: {{graded_lead2.info_lead.wanted_vehicle}}</div>
                <div class="heading">Date In: {{fmt_date(graded_lead2.info_lead.lead_arrived_date)}}</div>

                <div class="heading pb-0">Grader's Comments:</div>
                <div class="comments" v-html="txt_to_html(graded_lead2.comments_external)"> </div>


                <div v-if="$auth.profile.acct_type === 'AGENCY' && graded_lead2.comments_internal !== ''" class="mt-3">
                  <div class="heading pb-0">Internel Comments (Agency View Only):</div>
                  <div class="comments" v-html="txt_to_html(graded_lead2.comments_internal)"> </div>
                </div>


                <div class="pt-3">
                  <div class="heading">Questions:</div>
                  <div v-for="(q, i) in graded_lead2.questions" class="pb-3" :key="i">
                    <span class="q-heading"> Question {{i+1}}:</span> {{clean_txt(q.question)}} <br>
                    <div v-if="q.answer != null">
                      <span class="q-heading">Answer {{i+1}}:</span> {{q.answer}}
                    </div>
                  </div>

                </div>

                <div class="pt-3">
                  Links:
                  <div v-for="(item, i) in graded_lead2.additional_data.info_urls" :key="i">
                    <a :key="i" style="color:blue;" :href="item" target="_blank">
                      {{item}}
                    </a>
                  </div>

                </div>
                <!--<div class="pt-2" v-if="!isPhone">-->
                <!--  Additional Files: <br>-->
                <!--  <template v-for="(item, i) in graded_lead2.additional_data.files">-->
                <!--    <div :key="i" class="pb-2">-->
                <!--      <a :key="item.file_id" @click="download_file(item.file_id)" style="color:blue;"> Download File {{i+1}}</a>-->
                <!--    </div>-->

                <!--  </template>-->
                <!--</div>-->
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <!--<v-card-actions>-->
          <!--<v-spacer></v-spacer>-->
          <!--<v-btn color="primary" @click="show_viewGrade=false">Close</v-btn>-->
          <!--<v-btn color="primary" @click="tmp">get data</v-btn>-->
        <!--</v-card-actions>-->
      </v-card>




  </div>
</template>

<style scoped>
  .heading{
    padding-bottom: 10px;
    font-size: large;
    font-weight: bold;
    color: #6a6a6a;
  }
  .q-heading{
    color: #6a6a6a;
    font-weight: bold;
  }

  .comments{
    /*border-color: gray;*/
    border: 1px solid #c2c2c2;
    padding: 5px;
  }


  td{
     padding-left: 5px;
     padding-right: 5px;
  }
</style>


<script>
   import axios from 'axios';
   import _ from 'lodash';
   import data_getters from '../mixins/data_getters';

   export default {

      mixins: [data_getters],
      props: {
         graded_lead: {default: ()=> null},
         grade_id: {default: ()=> null},
         show: null,
         showX: {type: Boolean, default: () => true}, //controls if the close X btn is shown
      },
      data() {
         return {
            file_data: null,
            show_audio_controls: true,
            event_list: [],
            curriculum: {},
            graded_lead2: null,
         };
      },

      computed:{
        isPhone(){
           if (this.curriculum.email_template === 'PHONE' && this.graded_lead2.additional_data.files.length > 0) return true;
           return false;
        },

         percent_played(){
           if (this.graded_lead2.player_data == undefined)
              return [];

           let ans = [];
            let pd = this.graded_lead2.player_data;

           if (this.isManager){
              for (let x in pd){
                 ans.push({
                    percent: pd[x].percent_completed,
                    name: pd[x].user_info.name,
                    email: pd[x].user_info.email,
                 });
              }

              console.log('debug')
              let sp = this.graded_lead2.sales_people;
              for (let x in sp){
                 if (pd[sp[x].user_id] == undefined){
                    ans.push({
                       percent: 0,
                       name: sp[x].name,
                       email: sp[x].email,
                    })
                 }
              }


           }else{
              let user_id = this.$auth.profile.user_id;
              if (pd[user_id] !== undefined){
                 ans.push({
                    percent: pd[user_id].percent_completed,
                    name: pd[user_id].user_info.name,
                    email: pd[user_id].user_info.email,
                 });
              }
           }

           ans = ans.sort((a, b) => a.percent < b.percent ? 1 : -1);
           return ans;

         },

         isManager(){
           return  ['Admin', 'Manager', 'AcctManager', 'Grader'].includes(this.$auth.profile.user_role);
         }
      },


      methods:{


         separator(ix, array){
            if (ix < array.length-1){
               return ', ';
            }

            return '';
         },

         close(){
            this.$emit('close-parent')
         },

         async download_file(filename){

            let token = await this.$auth.getAxiosHeader();
            let url = this.$baseUrlApi + '/getFile';
            // let ext = filename.split('.');
            // ext = ext[ext.length];
            // let type = 'application/'+ext;


            let save_name = filename.split('/');
            save_name = save_name[save_name.length-1];

            axios({
               url: url,
               method: 'post',
               data: {file_key: filename},
               responseType: 'blob', // important
               headers: token['headers'],
            }).then((response) => {
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', save_name );
               document.body.appendChild(link);
               link.click();
            });

         },

         // tmp(){
         //    this.get_graded_lead2({_id: '5d6700f73d8a63db28fc911a'});
         // },

         fmt_date(d){
            //assumes d is a string in yyyy-mm-dd fmt.  returns date in mm/dd/yyyy fmt
            let tmp = d.split('-');
            return `${tmp[1]}/${tmp[2]}/${tmp[0]}`;
         },



         clean_txt(txt){
           return txt.replace('<br>', ' ');
         },

         txt_to_html(txt){
            if (txt)
              return txt.replace(/(\r\n|\n|\r)/gm,"<br>");
            else
               return '';
         },


         async get_graded_lead_local(){


            try {
               // let {data} = await axios.post(url, {match: {_id: grade_id, agency_id: }, get_q_data: true,  get_player_data: true}, token);
               // return data[0];

               let data = await this.get_graded_leads({_id: this.grade_id, get_q_data:true, get_player_data: 'percent'})

               if (data.length > 0){
                  return data[0];
               }
               return null;
            }
            catch(err){
               console.log(err);
               return null;


            }
         },

         player_event(event){
            // console.log('event', event)

            if (this.$refs.mp3_player){

               let e2 = {
                  event: event.type,
                  player_position:  this.$refs.mp3_player.currentTime,
                  player_time_total: this.$refs.mp3_player.duration,
                  player_volume: this.$refs.mp3_player.volume,
                  player_muted: this.$refs.mp3_player.muted,

                  time_stamp: new Date(),
                  // user_id: this.$auth.profile.user_id
               }
               this.event_list.push(e2)
               // if (event.type === 'play') this.filter_seek_event();
               console.log('event2', e2)
               this.debouncd_event_update();
            }


         },

         filter_seek_event(){
           //filter out the pause/play events that happen before/after a seeked event
            let n = this.event_list.length;
           if (n < 3){
              return;
           }

           if  (this.event_list[n-3].player_position === this.event_list[n-2].player_position
               && this.event_list[n-2].player_position === this.event_list[n-1].player_position){
              console.log('i ran')
              this.event_list.splice(n-3, 1);
              this.event_list.pop();
           }

         },
         async update_player_info(){
            try{
               let token = await this.$auth.getAxiosHeader();
               let url = this.$baseUrlApi + '/updateGradedLeadPlayerData';
               let post_data = {
                  user_id: this.$auth.profile.user_id,
                  user_name: this.$auth.profile.name,
                  user_email: this.$auth.profile.email,
                  lead_id: this.graded_lead2._id,

                  player_data: this.event_list,
               }
               this.event_list = [];
               var res = await axios.post(url, post_data, token);

            }
            catch(e){
               console.log(e)
            }
         },

         async get_file_data(filename){
            let token = await this.$auth.getAxiosHeader();
            let url = this.$baseUrlApi + '/getFile';
            // let ext = filename.split('.');
            // ext = ext[ext.length];
            // let type = 'application/'+ext;


            let save_name = filename.split('/');
            save_name = save_name[save_name.length-1];

            axios({
               url: url,
               method: 'post',
               data: {file_key: filename},
               responseType: 'blob', // important
               headers: token['headers'],
            }).then((response) => {
               console.log('response', response)
               this.file_data = window.URL.createObjectURL(new Blob([response.data]));

            });


         },
      },
      async created(){

         if (this.graded_lead != null){
            this.graded_lead2 = this.graded_lead;
         }
         else{
            this.graded_lead2 = await this.get_graded_lead_local({grade_id: this.grade_id});
         }


         let files = [];
         if (this.graded_lead2.additional_data.files != undefined){
            files = this.graded_lead2.additional_data.files;
         }
         if (files.length === 1  ){
            this.get_file_data(files[0].file_id)
         }

         let tmp = await  this.get_curricula({_id: this.graded_lead2.curriculum.id});
         if (tmp.length === 1){
            this.curriculum = tmp[0];
         }
         this.debouncd_event_update = _.debounce(this.update_player_info, 500);

      },

      async mounted(){

      },

      async beforeDestroy() {
         if (this.$refs.mp3_player && !this.$refs.mp3_player.paused){
            let e2 = {
               event: 'close_page',
               player_position:  this.$refs.mp3_player.currentTime,
               player_time_total: this.$refs.mp3_player.duration,
               player_volume: this.$refs.mp3_player.volume,
               player_muted: this.$refs.mp3_player.muted,
               time_stamp: new Date(),
            }
            this.event_list.push(e2)
         }


         if (this.event_list.length > 0)
            await this.update_player_info();
      }
   };
</script>


